import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import { Button, Checkbox, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, MenuItem, TextField } from '@material-ui/core';

interface PrintOrderListDialogProps {
  closeFn: () => void;
  confirmFn: (isTestingDocument: boolean, includeCompanyDetails: boolean, selectedPrintLang: string) => void;

  open: boolean;
}

const PrintOrderListDialog: FC<PrintOrderListDialogProps> = ({ closeFn, confirmFn, open }) => {
  const { t } = useTranslation();
  const [isTestingDocument, setIsTestingDocument] = useState<boolean>(false);
  const [includeCompanyDetails, setIncludeCompanyDetails] = useState<boolean>(false);

  const currentLang = t('_.lang');
  const [preferredPrintLang, setPreferredPrintLang] = useState<string>(currentLang);
  const availableLanguages: Array<string> = ["en", "it"];

  return (
    <Dialog open={open} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">{t('orderList.print order list')}</DialogTitle>
      <DialogContent>
        <FormGroup>
          <FormControlLabel
            label={''}
            control={
              <TextField fullWidth variant="outlined" label={t('print.custom language.preferred')}
                select value={preferredPrintLang} style={{ marginBottom: '16px' }}
                onChange={e => { setPreferredPrintLang(e.target.value); }}
              >
                {
                  availableLanguages.map((value, key) =>
                    <MenuItem key={key} value={value}>{t(`print.custom language.${value}`)}</MenuItem>
                  )
                }
              </TextField>
            }
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={isTestingDocument}
                onClick={() => setIsTestingDocument(!isTestingDocument)} />
            }
            label={t('orderList.include testing report')}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={includeCompanyDetails}
                onClick={() => setIncludeCompanyDetails(!includeCompanyDetails)} />
            }
            label={t('orderList.include my details')}
          />
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeFn} color="secondary">
          {t('label.cancel')}
        </Button>
        <Button onClick={() => {
          closeFn();
          confirmFn(isTestingDocument, includeCompanyDetails, preferredPrintLang)
        }}
          color="primary" autoFocus
        >
          {t('label.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export { PrintOrderListDialog };
